import React from "react";
import { useTranslation } from "react-i18next";

import { $Affix, $PageHeader } from "us.common/components";
import { ReportViewer } from "./components";
import "./PowerBiDashboard.scss";
import { useSafeBackNavigation } from "us.helper/navigation";

/**
 * @description - Power BI dashboard component
 * @link JIRA - https://teams.microsoft.com/l/message/19:a5f790440f654c2292022bd95a135eb8@thread.v2/1761109622326?context=%7B%22contextType%22%3A%22chat%22%7D
 * @author Roshan Maddumage <roshanma@unicorn-solutions.com>
 * @since 22/10/2025
 */
const PowerBiDashboard = () => {
  const { t } = useTranslation();
  const goBack = useSafeBackNavigation();

  return (
    <div className="powerbi-page">
      <$Affix offsetTop={48}>
        <div className="page-header header-border">
          <div className="d-flex align-items-center">
            <$PageHeader
              className="px-0"
              onBack={goBack}
              title={t(
                "US.COLLECTION.ADMIN:POWER_BI_DASHBOARD.POWER_BI_DASHBOARD",
              )}
            />
          </div>
        </div>
      </$Affix>
      <div className="space-content">
        <ReportViewer />
      </div>
    </div>
  );
};

export default PowerBiDashboard;
